export function extractKeys(data: any[]): string[] {
    return data?.map(item => item.key);
  }
  